import { doHttp } from '../utils/common'
import { HTTP_TYPE_GET, HTTP_TYPE_POST, CONTENT_TYPE_FILE } from '../utils/config'

/**
 * 新增/编辑
 * @param params
 * @param companyId
 * @return {*}
 */
export function apiEdit (params, companyId) {
  return doHttp(`/product/addOrUpdate.action?companyId=${companyId}`, HTTP_TYPE_POST, params)
}

/**
 * 删除
 * @param id
 * @return {*}
 */
export function apiDelete (id) {
  let params = { id }
  return doHttp('/product/delete.action', HTTP_TYPE_GET, params)
}

/**
 * 详情
 * @param id
 * @return {*}
 */
export function apiDetail (id) {
  let params = { id }
  return doHttp('/product/detail.action', HTTP_TYPE_GET, params)
}

/**
 * 列表
 * @param companyId
 * @param name
 * @param {*} status 0:未禁用 1:已禁用
 * @param code
 * @param pageIndex
 * @param pageSize
 * @return {*}
 */
export function apiList (params, status, pageIndex = 1, pageSize = 20) {
  return doHttp(`/product/list.action?status=${status}&pageIndex=${pageIndex}&pageSize=${pageSize}`, HTTP_TYPE_POST, params)
}

/**
 * excel导入
 * @param companyId
 * @param params
 * @return {*}
 */
export function apiUpload (companyId, params) {
  return doHttp(`/product/excel/upload.api?companyId=${companyId}`, HTTP_TYPE_POST, params, CONTENT_TYPE_FILE)
}

/**
 * sap导入
 * @param companyId
 * @return {*}
 */
export function apiSap (companyId) {
  let params = { companyId }
  return doHttp('/product/sap/edit.api', HTTP_TYPE_GET, params)
}
